import { ErrorPage } from 'components/AlertMessage'
import DelayedLoadingView from 'components/DelayedLoadingView'
import { Suspense } from 'react'
import { useOutletContext } from 'react-router-dom'
import { useHasFeature } from 'hooks/useHasFeature'
import { t } from 'i18n/translation'
import { isAuthorized } from './AuthorizeService'

const RenderRoute = props => {
  const { component: Component, roles, flag } = props
  const { userRoles } = useOutletContext()
  const isAuthorize = userRoles && isAuthorized(userRoles, roles)
  const hasFeature = useHasFeature(flag)

  if (flag && !hasFeature) {
    return <ErrorPage message={t('errorCode.NotAuthorized')} />
  }

  return userRoles ? (
    !isAuthorize ? (
      <ErrorPage message={t('errorCode.NotAuthorized')} />
    ) : (
      <Suspense fallback={<DelayedLoadingView />}>
        <Component userRoles={userRoles} />
      </Suspense>
    )
  ) : (
    <></>
  )
}

export default RenderRoute
